export enum ContentTypes {
  TEST = 'AdvizedTest',
  TOPLIST = 'AdvizedToplist',
  TOPLIST_HEADLINE = 'ToplistHeadline',
  GUIDE = 'ExpertGuide',
}

export enum ExpertUserCardSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
}
